(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  // Header Menu Hover Functionality
  const headerWrapper = document.querySelector('.header-wrapper');
  const enableMenuHover = headerWrapper ? headerWrapper.dataset.enableMenuHover === 'true' : false;
  
  // Add hover functionality to existing header-menu elements
  function setupMenuHover(menuElement) {
    if (!menuElement || menuElement.hoverSetup) return;
    
    const details = menuElement.querySelector('details');
    if (!details) return;
    
    let hoverTimeout = null;
    
    function handleMouseEnter() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      hoverTimeout = setTimeout(() => {
        if (details && !details.open) {
          details.setAttribute('open', '');
        }
      }, 150);
    }
    
    function handleMouseLeave() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      hoverTimeout = setTimeout(() => {
        if (details && details.open) {
          details.removeAttribute('open');
        }
      }, 200);
    }
    
    function setupHover() {
      if (menuElement.hoverSetup) return;
      menuElement.hoverSetup = true;
      menuElement.addEventListener('mouseenter', handleMouseEnter);
      menuElement.addEventListener('mouseleave', handleMouseLeave);
    }
    
    function removeHover() {
      if (!menuElement.hoverSetup) return;
      menuElement.hoverSetup = false;
      menuElement.removeEventListener('mouseenter', handleMouseEnter);
      menuElement.removeEventListener('mouseleave', handleMouseLeave);
      if (details && details.open) {
        details.removeAttribute('open');
      }
    }
    
    // Setup hover if enabled
    if (enableMenuHover && window.innerWidth >= 990) {
      setupHover();
    }
    
    // Handle resize
    window.addEventListener('resize', () => {
      if (enableMenuHover && window.innerWidth >= 990 && !menuElement.hoverSetup) {
        setupHover();
      } else if ((!enableMenuHover || window.innerWidth < 990) && menuElement.hoverSetup) {
        removeHover();
      }
    });
    
    // Store methods for potential close() calls
    menuElement.close = function() {
      if (details) {
        details.removeAttribute('open');
      }
    };
  }
  
  // Setup hover for all header-menu elements
  if (enableMenuHover) {
    document.querySelectorAll('header-menu').forEach(setupMenuHover);
    
    // Also setup for dynamically added elements
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.tagName === 'HEADER-MENU') {
              setupMenuHover(node);
            }
            node.querySelectorAll && node.querySelectorAll('header-menu').forEach(setupMenuHover);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  // Setup hover for products-mega-menu elements
  function setupProductsMegaMenuHover(menuElement) {
    if (!menuElement || menuElement.hoverSetup) return;
    
    const details = menuElement.querySelector('details');
    if (!details) return;
    
    let hoverTimeout = null;
    
    function handleMouseEnter() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      hoverTimeout = setTimeout(() => {
        if (details && !details.open) {
          details.setAttribute('open', '');
        }
      }, 150);
    }
    
    function handleMouseLeave() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      hoverTimeout = setTimeout(() => {
        if (details && details.open) {
          details.removeAttribute('open');
        }
      }, 200);
    }
    
    function setupHover() {
      if (menuElement.hoverSetup) return;
      menuElement.hoverSetup = true;
      menuElement.addEventListener('mouseenter', handleMouseEnter);
      menuElement.addEventListener('mouseleave', handleMouseLeave);
    }
    
    function removeHover() {
      if (!menuElement.hoverSetup) return;
      menuElement.hoverSetup = false;
      menuElement.removeEventListener('mouseenter', handleMouseEnter);
      menuElement.removeEventListener('mouseleave', handleMouseLeave);
      if (details && details.open) {
        details.removeAttribute('open');
      }
    }
    
    // Setup hover if enabled
    if (enableMenuHover && window.innerWidth >= 990) {
      setupHover();
    }
    
    // Handle resize
    window.addEventListener('resize', () => {
      if (enableMenuHover && window.innerWidth >= 990 && !menuElement.hoverSetup) {
        setupHover();
      } else if ((!enableMenuHover || window.innerWidth < 990) && menuElement.hoverSetup) {
        removeHover();
      }
    });
  }
  
  // Setup hover for all products-mega-menu elements
  if (enableMenuHover) {
    document.querySelectorAll('products-mega-menu').forEach(setupProductsMegaMenuHover);
    
    // Also setup for dynamically added elements
    const productsObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.tagName === 'PRODUCTS-MEGA-MENU') {
              setupProductsMegaMenuHover(node);
            }
            node.querySelectorAll && node.querySelectorAll('products-mega-menu').forEach(setupProductsMegaMenuHover);
          }
        });
      });
    });
    productsObserver.observe(document.body, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
